import React from "react";
import UserLayout from "../../components/user/UserLayout";
import { Card, Row, Col } from "react-bootstrap";
import { FaFileMedical, FaCheckCircle, FaInfoCircle } from "react-icons/fa";

const MajistralSUT = () => {
  return (
    <UserLayout>
      <div className="mb-4">
        <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
          Majistral SUT Bilgileri
        </h2>
        <p className="text-muted">
          Majistral preparatların SGK kapsamında geri ödeme koşullarına ilişkin en güncel SUT
          (Sağlık Uygulama Tebliği) bilgileridir. Bu sayfada majistral ürünlerin hangi durumlarda
          karşılandığını özet hâlde bulabilirsiniz.
        </p>
      </div>

      {/* 📌 Büyük Banner */}
      <Card className="shadow-sm rounded-4 overflow-hidden mb-4">
        <img
          src="/sut_banner.jpg"
          alt="SUT Majistral"
          className="w-100"
          style={{ maxHeight: "300px", objectFit: "cover" }}
        />
      </Card>

      {/* 📌 SUT Kısa Bilgi Kartları */}
      <Row className="g-4 mb-4">
        <Col md={4}>
          <Card className="p-4 shadow-sm rounded-4 h-100 text-center">
            <FaFileMedical size={40} className="text-primary mb-3" />
            <h5 className="fw-bold">SGK Ödeme Kuralları</h5>
            <p className="text-muted mb-0">
              Majistral ilaçların ödemesi belirli endikasyon ve doz kriterlerine bağlıdır.
            </p>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="p-4 shadow-sm rounded-4 h-100 text-center">
            <FaCheckCircle size={40} className="text-success mb-3" />
            <h5 className="fw-bold">Geri Ödeme Kapsamı</h5>
            <p className="text-muted mb-0">
              Belirli SKS, kronik hastalıklar ve özel durumlar için ödeme yapılmaktadır.
            </p>
          </Card>
        </Col>

        <Col md={4}>
          <Card className="p-4 shadow-sm rounded-4 h-100 text-center">
            <FaInfoCircle size={40} className="text-warning mb-3" />
            <h5 className="fw-bold">Önemli Detaylar</h5>
            <p className="text-muted mb-0">
              Ret oranı yüksek olan majistraller ve SGK istisnaları hakkında bilgiler.
            </p>
          </Card>
        </Col>
      </Row>

      {/* 📌 SUT Detay Bölümü */}
      <Card className="p-4 shadow-sm rounded-4 mb-4">
        <h4 className="fw-bold mb-3" style={{ color: "#2D8A7A" }}>
          SUT Madde Detayları
        </h4>

        <ul className="text-muted" style={{ lineHeight: "1.7" }}>
          <li>
            Majistral ilaçlar yalnızca hekim tarafından düzenlenen reçetelerde, belirlenen
            endikasyonlarla SGK kapsamında karşılanır.
          </li>
          <li>
            “Endikasyon dışı” majistraller SGK kapsamına girmez ve tam ücret olarak hastaya yansır.
          </li>
          <li>
            Bazı formüllerde maksimum hazırlanabilir miktar sınırlaması bulunmaktadır.
          </li>
          <li>
            Aynı etkin maddeyi içeren ticari ürün varsa, majistralin geri ödeme kapsamı değişebilir.
          </li>
          <li>
            Pediatrik hastalarda özel majistral formlar daha geniş kapsamda değerlendirilir.
          </li>
        </ul>
      </Card>

      {/* 📌 Görsel + Açıklama Kutusu */}
      <Card className="p-4 shadow-sm rounded-4 mb-4 d-flex flex-row gap-3 align-items-center">
        <img
          src="/sut_info.jpg"
          alt="SUT Info"
          style={{
            width: "160px",
            height: "160px",
            objectFit: "cover",
            borderRadius: "12px",
          }}
        />

        <div>
          <h5 className="fw-bold" style={{ color: "#2D8A7A" }}>
            Ek Açıklama
          </h5>
          <p className="text-muted mb-0">
            Bu bölümde SGK tarafından yayınlanan resmi SUT güncellemelerine göre majistral
            ilaçlarla ilgili son bilgiler yer alır. Her yeni SUT değişikliğinde bu alan güncellenir.
          </p>
        </div>
      </Card>

      {/* 📌 Reklam Alanı */}
      <Card
        className="p-4 shadow-sm rounded-4 text-center"
        style={{ background: "#f8fafc", border: "2px dashed #cdd6dd" }}
      >
        <h6 className="fw-bold mb-2">Reklam Alanı</h6>
        <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
          Bu alana reklam verebilirsiniz. Bizimle iletişime geçin.
        </p>
      </Card>
    </UserLayout>
  );
};

export default MajistralSUT;
